import Vue from 'vue'
import Router from 'vue-router'
import Store from './store'

import Login from '@/views/login'
import Member from '@/views/member'
import Study from '@/views/study'
import Paper from '@/views/paper'
import WrongBook from '@/views/exercise/WrongBook'
import FavExercise from '@/views/exercise/FavExercise'
import CourseWare from '@/views/exercise/CourseWare'

Vue.use(Router)


const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Member',
      meta: {
        title: "个人中心",
        requireAuth: true
      },
      component: Member
    },
    {
      path: '/login',
      name: 'Login',
      meta: {
        title: "登陆"
      },
      component: Login
    },
    {
      path: '/study/:cid',
      name: 'Study',
      meta: {
        title: "课程",
        requireAuth: true
      },
      component: Study
    },
    {
      path: '/paper/:id',
      name: 'Paper',
      meta: {
        title: "试卷",
        requireAuth: true
      },
      component: Paper
    },
    {
      path: '/exercise/WrongBook/:cid',
      name: 'WrongBook',
      meta: {
        title: "错题本",
        requireAuth: true
      },
      component: WrongBook
    },
    {
      path: '/exercise/FavExercise/:cid',
      name: 'FavExercise',
      meta: {
        title: "习题收藏",
        requireAuth: true
      },
      component: FavExercise
    },
    {
      path: '/exercise/CourseWare/:cid',
      name: 'CourseWare',
      meta: {
        title: "课程资料",
        requireAuth: true
      },
      component: CourseWare
    }
  ]
})

router.afterEach((to, from) => {
  // 登录判断
  let needLoginPage = [
    'Member',
    'Study',
    'Paper',
    'WrongBook',
    'FavExercise'
  ];
  if (needLoginPage.indexOf(to.name) != -1) {
    Store.dispatch('isLogin');
  }
})

const routerPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return routerPush.call(this, location).catch(error => error)
}


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js